<template>
  <div class="row">
    <el-dialog
      top
      :title="title"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      @open="openModalMethod()"
      :visible.sync="isShow"
      style="margin: 0 auto"
      class="editCompanyPopup col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="row">
        <div class="col-12 investor-table-wrapper">
          <div class="row">
            <div class="col-12">
              <div>
                {{
                  value.data.user_investment_status != "Fund"
                    ? "Company Name"
                    : "Fund Name"
                }}
              </div>
              <input
                type="text"
                class="form-control"
                v-model="value.data.name"
                :disabled="
                  value.data &&
                  value.data.permalink &&
                  value.data.permalink.length > 0
                    ? true
                    : false
                "
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>Logo Url</div>
              <input
                type="text"
                v-model="value.data.logo_url"
                class="form-control"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>Industry</div>
              <input
                type="text"
                v-model="value.data.category_data"
                class="form-control"
              />
            </div>
          </div>
           <div class="row mb-2">
           <div class="col-12">
              <div>Status</div>
              <el-select
                class
                size="large"
                placeholder="Select Stage"
                v-model="value.data.status"
              >
                <el-option
                  v-for="option in vals.STATUS_DEFINES"
                  class
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>Sector</div>
              <vue-single-select
                v-model="value.data.sector"
                placeholder="Select Sector"
                :options="sortedSectors"
                class="form-control sectorVueSingleSelect"
              ></vue-single-select>
            </div>
            <div class="col-6">
              <div>Founding Date</div>
              <input
                class="todo-form-date todo-form form-control"
                type="date"
                v-model="value.data.founding_date"
              />
            </div>
          </div>
          <div
            class="row mb-2"
            v-if="value.data.user_investment_status != 'Fund'"
          >
            <div class="col-6">
              <div>Stage I Invested</div>
              <el-select
                class
                size="large"
                placeholder="Select Stage"
                v-model="value.data.stage_i_invested"
              >
                <el-option
                  v-for="option in vals.STAGE_DEFINES"
                  class
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
              <!-- <input type="text" class="form-control" v-model="value.data.stage_i_invested" /> -->
            </div>
            <div class="col-6">
              <div>Current Stage</div>
              <el-select
                class
                size="large"
                placeholder="Select Stage"
                v-model="value.data.stage"
              >
                <el-option
                  v-for="option in vals.STAGE_DEFINES"
                  class
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="row" v-if="value.data.user_investment_status == 'Fund'">
            <div class="col-6">
              <div>Investment Date</div>
              <input
                class="todo-form-date todo-form form-control"
                type="date"
                v-model="value.data.fund_investment_date"
              />
            </div>
            <div class="col-6">
              <div style="margin-bottom: 5px">Investment Stage</div>
              <el-select
                class
                size="large"
                placeholder="Select Stage"
                v-model="value.data.investor_stage"
              >
                <el-option
                  v-for="item in vals.stageDropdown"
                  class
                  :value="item"
                  :label="item"
                  :key="item"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="row mb-2"
            v-if="value.data.user_investment_status != 'Fund'"
          >
            <div class="col-12">
              <div>Referred By</div>
              <vue-bootstrap-typeahead
                :data="existingRefers"
                v-model="referred_by"
                v-if="value.isShow"
                class="diligenceReferredByClass"
                :serializer="usersSerializer"
                ref="referralRef"
                :minMatchingChars="minMatchingChars"
                placeholder="Enter Referred by"
                @hit="onAfterUserSelection"
              >
                <template slot="suggestion" slot-scope="{ data }">
                  <div class="d-flex">
                    <div style="padding-top: 6px">
                      {{ data.name }} {{ emailShow(data.email) }}
                    </div>
                  </div>
                </template>
              </vue-bootstrap-typeahead>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>Tags</div>
              <b-form-tags
                input-id="tags-basic"
                v-model="value.data.tags"
                add-on-change
                separator=","
                placeholder="Enter Tags separated by comma"
                class="form-control team-form"
              ></b-form-tags>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>Contact Email</div>
              <input
                type="text"
                class="form-control"
                placeholder="Contact Email"
                v-model="value.data.contact_email"
              />
            </div>
          </div>
          <div class="row"></div>
          <div class="row">
            <div class="col-6">
              <div>Geography</div>
              <input
                type="text"
                id="autocompleteMap"
                class="form-control"
                v-model="value.data.geography"
              />
            </div>
            <div class="col-6">
              <div>No Of Employees</div>
              <input
                type="text"
                class="form-control"
                v-model="value.data.employee_count"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>Twitter</div>
              <input
                type="text"
                class="form-control"
                v-model="value.data.twitter"
              />
            </div>
            <div class="col-6">
              <div>Website</div>
              <input
                type="text"
                class="form-control"
                v-model="value.data.website"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>Facebook</div>
              <input
                type="text"
                class="form-control"
                v-model="value.data.facebook"
              />
            </div>
            <div class="col-6">
              <div>LinkedIn</div>
              <input
                type="text"
                class="form-control"
                v-model="value.data.linkedin"
              />
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-6">
              <div>Twitter</div>
              <input type="text" class="form-control" v-model="value.data.twitter" />
            </div>
          </div>-->
          <div class="row">
            <div class="col-12">
              <div>Description</div>
              <textarea
                placeholder="Description"
                rows="4"
                cols="50"
                class="form-control"
                v-model="value.data.description"
              ></textarea>
            </div>
          </div>

          <div class="row"></div>
          <div slot="footer" class="dialog-footer" style>
            <div
              style="border: 0.8px solid #ededed; opacity: 1; margin-top: 18px"
            ></div>
            <div
              class="col-xl edit-company-action-button-row"
              style="padding: 0px; margin-top: 30px"
            >
              <button
                type="button"
                class="todo-form-cancel-button btn-outline-secondary"
                @click.prevent="handleCancel"
              >
                Cancel
              </button>
              <button
                type="button"
                class="todo-form-submit-button btn btn-primary"
                @click.prevent="companySave()"
                :disabled="showSpinner"
              >
                Save
                <b-spinner
                  v-if="showSpinner"
                  style="float: right"
                  small
                  label="Loading..."
                ></b-spinner>
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      center
      width="494px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="showTodoRemainderModal"
    >
      <div class="row container">
        <p
          style="padding-left: 1.3rem; white-space: normal; word-break: normal"
        >
          Would you like to start counting down the 180 lock up period for this
          company? We'll send you a heads-up before this period is over...
          BTW,congrats on the IPO!
        </p>
      </div>
      <div class="row">
        <div
          class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xs-6"
          style="padding-left: 2rem"
        >
          <button
            type="button"
            class="todo-form-submit-button btn btn-primary"
            @click="startLockupPeriod()"
          >
            Yes
          </button>
        </div>
        <div
          class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xs-6"
          style="padding-left: 3rem"
        >
          <button
            type="button"
            class="todo-form-submit-button btn btn-primary"
            @click.prevent="
              writeToServer();
              showTodoRemainderModal = !showTodoRemainderModal;
            "
            style="width: 135px"
          >
            No
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { mapGetters } from "vuex";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
import { Company, patchCompany } from "../../../models/Company";
import { vals } from "../../../util";
import VueSingleSelect from "vue-single-select";
import { JS } from "aws-amplify";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
export default {
  name: "editCompany",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    VueSingleSelect,
    VueBootstrapTypeahead,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
    },
  },
  data() {
    return {
      vals,
      referred_by: "",
      minMatchingChars: 1,
      isSelected: false,
      existingRefers: [],
      teams: [],
      showSpinner: false,
      oldStatus: "",
      showTodoRemainderModal: false,
    };
  },
  computed: {
    ...mapGetters("referrer", ["teamMembers"]),
    sortedSectors() {
      let sectorList = this.vals.sectorList;
      sectorList.sort((a, b) => a.localeCompare(b));
      return sectorList;
    },
    isShow: {
      get() {
        if (this.value.isShow) {
          this.initializeData();
        }
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
        this.$emit("input", this.value);
      },
    },
    moment() {
      return moment;
    },
    title() {
      if (this.value.data.user_investment_status == "Fund")
        return "Edit Fund Details";
      else return "Edit Company Details";
    },
  },
  watch: {
    referred_by: _.debounce(function (addr) {
      if (addr.length > 0) {
        this.getReferrers(addr);
      }
    }, 500),
  },
  methods: {
    openModalMethod() {
      this.oldStatus = this.value.data.status ? this.value.data.status : "";
    },
    startLockupPeriod() {
      this.value.data.todo_remainder = new Date();
      this.writeToServer();
      this.showTodoRemainderModal = false;
    },
    emailShow(item) {
      let itemEmail = item ? `<${item}>` : "";
      return itemEmail;
    },
    initializeData() {
      setTimeout(() => {
        this.isSelected = false;
        this.referred_by =
          this.value.data.referred_by && this.value.data.referred_by.name
            ? this.value.data.referred_by.name
            : "";
        if (this.$refs && this.$refs.referralRef) {
          this.$refs.referralRef.inputValue =
            this.value.data.referred_by && this.value.data.referred_by.name
              ? this.value.data.referred_by.name
              : "";
        }
      }, 1000);
      this.teams =
        this.teamMembers && this.teamMembers.length > 0
          ? JSON.parse(JSON.stringify(this.teamMembers))
          : [];
      this.teams.map((item) => {
        item.isTeam = true;
      });
    },
    handleCancel() {
      this.isShow = false;
      this.showSpinner = false;
    },
    usersSerializer(data) {
      return data.name;
    },
    onAfterUserSelection(selectedValue) {
      let oldValue = {};
      if (
        this.value.data &&
        this.value.data.referred_by &&
        this.value.data.referred_by.oldValue
      )
        oldValue = JSON.parse(
          JSON.stringify(this.value.data.referred_by.oldValue)
        );
      else if (this.value.data && this.value.data.referred_by)
        oldValue = JSON.parse(JSON.stringify(this.value.data.referred_by));

      this.value.data.referred_by = {
        value: selectedValue.name,
        changed: true,
        type:
          this.value.data.user_investment_status == "Diligence"
            ? "Diligence"
            : "Portfolio_Item",
        oldValue,
      };
      if (selectedValue && selectedValue.isTeam) {
        this.value.data.referred_by.key = selectedValue.account._id;
        this.value.data.referred_by.isTeam = true;
      } else {
        this.value.data.referred_by.key = selectedValue._id;
        this.value.data.referred_by.isTeam = false;
      }
      this.isSelected = true;
      this.referred_by = "";
    },
    getReferrers() {
      let self = this;
      this.isSelected = false;
      api
        .get(
          `/attributors/${self.$route.params.workspace_id}/${self.referred_by}`
        )
        .then((data) => {
          self.existingRefers = [];
          self.existingRefers = [...self.teams, ...data.data.encrypt.data];
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    companySave() {
      let self = this;
      let serverData = JSON.parse(JSON.stringify(this.value.data));
      if (
        serverData.status.toLowerCase() == "ipo" &&
        self.oldStatus.toLowerCase() != "ipo"
      ) {
        self.showTodoRemainderModal = true;
      } else if (
        self.oldStatus.toLowerCase() == "ipo" &&
        serverData.status.toLowerCase() != "ipo"
      ) {
        self.value.data.todo_remainder = "";
        self.writeToServer();
      } else {
        self.writeToServer();
      }
    },
    writeToServer() {
      const self = this;
      this.showSpinner = true;
      let oldValue =
        this.value.data && this.value.data.referred_by
          ? JSON.parse(JSON.stringify(this.value.data.referred_by))
          : {};
      if (!this.isSelected && this.referred_by.length > 0) {
        this.value.data.referred_by = {
          key: "",
          value: this.referred_by,
          changed: true,
          isTeam: false,
          type:
            this.value.data.user_investment_status == "Diligence"
              ? "Diligence"
              : "Portfolio_Item",
          oldValue,
        };
      } else if (
        !this.isSelected &&
        this.referred_by.length == 0 &&
        oldValue.name &&
        oldValue.name.length > 0
      ) {
        this.value.data.referred_by = {
          key: "",
          value: "",
          type:
            this.value.data.user_investment_status == "Diligence"
              ? "Diligence"
              : "Portfolio_Item",
          isDeleted: true,
        };
      }
      if (this.value.data.referred_by) {
        if (
          this.value.data &&
          this.value.data.diligenceId &&
          this.value.data.user_investment_status &&
          this.value.data.user_investment_status == "Diligence"
        ) {
          this.value.data.referred_by.id = this.value.data.diligenceId;
        } else {
          this.value.data.referred_by.id = this.value.data._id;
        }
      }
      let serverData = JSON.parse(JSON.stringify(this.value.data));
      serverData.last_funding_round =
        serverData.last_funding_round &&
        serverData.last_funding_round != "-" &&
        serverData.last_funding_round != "Invalid date"
          ? serverData.last_funding_round
          : "";
      serverData.initial_investment =
        serverData.initial_investment &&
        serverData.initial_investment != "-" &&
        serverData.initial_investment != "Invalid date"
          ? serverData.initial_investment
          : "";
      if (!serverData.sector) {
        serverData.sector = "";
      }
      let company = patchCompany(serverData._id);
      if (company.update(serverData)) {
        return company
          .writeToServer()
          .then(() => {
            if (serverData.diligenceId) {
              let diligencePayload = JSON.parse(JSON.stringify(serverData));
              delete diligencePayload._id;
              delete diligencePayload.diligenceId;
              diligencePayload._id = serverData.diligenceId;
              diligencePayload.portfolio_item = serverData._id;
              self.$store
                .dispatch("diligence/apiPatchDiligenceInst", diligencePayload)
                .then((diligenceResp) => {
                  self.$store.dispatch(
                    "diligence_stage/apiFetchDiligenceStage"
                  );
                })
                .catch((err) => {
                  console.log("Fail to update diligence", { err });
                });
            }
            if (
              serverData.referred_by &&
              (serverData.referred_by.changed ||
                serverData.referred_by.isDeleted)
            ) {
              self.$emit("company-save", {});
              self.$store.dispatch("referrer/start");
            }
            if (serverData.tags && serverData.tags.length) {
              self.$store.dispatch("contacts/start");
            }
            self.$store
              .dispatch("portfolio/_apiFetchPortfolio")
              .then((data) => {
                self.handleCancel();
                if (self.$parent && self.$parent.tabulator) {
                  let data = self.$store.getters["portfolio/portfolioData"];
                  self.$parent.tabulator.setData(data);
                }
              });
            self.$toaster.success(`Saved Successfully`);
          })
          .catch((error) => {
            console.log("edit company error", error);
            this.$toaster.error("Failed to edit company");
          });
      }
    },
  },
  mounted() {
    setTimeout(() => {
      let input = document.getElementById("autocompleteMap");
      let autocomplete = new google.maps.places.Autocomplete(input, {
        types: ["(cities)"],
      });
      google.maps.event.addListener(autocomplete, "place_changed", () => {
        let place = autocomplete.getPlace();
        this.value.data.geography = place.formatted_address
          ? place.formatted_address
          : place.name;
      });
    }, 2000);
  },
};
</script>
<style lang="scss">
.editCompanyPopup .el-dialog {
  width: 505px;
  // height: 1060px;
  margin-top: 3vh !important;
}

.editCompanyPopup .el-dialog__header {
  padding-top: 25px;
  padding-left: 40px;
  padding-right: 25px;
  padding-bottom: 0;
}

.editCompanyPopup .el-dialog__title {
  color: #000000;
  font-size: 24px;
}

.editCompanyPopup .el-dialog__body {
  padding-left: 40px;
  padding-right: 45px;
  font-size: 14px;
  color: #000000cc;
}

.sectorVueSingleSelect {
  padding: 0;
  .search-input {
    height: 38px;
    border: 0;
  }
}
</style>
